import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 100 57",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0 .412)\"><rect fill=\"#fff\" height=\"56\" rx=\"9.286\" width=\"100\"></rect><g stroke-linecap=\"round\" stroke-width=\"4.271\"><path d=\"m25.67 17.717-9.46 8.152a2.786 2.786 0 0 0 0 4.22l9.46 8.152m47.573-20.524 9.46 8.152a2.786 2.786 0 0 1 0 4.22l-9.46 8.152\" stroke=\"#4fdca7\"></path><path d=\"m56.033 15.9-13.647 23.995\" stroke=\"#ededf4\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }